module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align-items-center"
  }, [_c('div', {
    staticClass: "p-3",
    staticStyle: {
      "max-height": "50%"
    }
  }, [_c('p', {
    staticClass: "ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-3"
  }, [_c('div', {
    staticClass: "mx-auto w-100",
    staticStyle: {
      "height": "50vh"
    },
    attrs: {
      "id": "youtube-video"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70a6f672"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/player/page/Youtube.vue
// module id = 113
// module chunks = 0